import React, { useEffect, useRef, useState } from "react";
import {
  Card,
  Typography,
  Input,
  Empty,
  Spin,
  Button,
  Space,
  Divider,
  Tooltip,
} from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  currentDiaryDetail,
  currentDiaryTopic,
  diaryStatus,
  entriesLoader,
  fetchDiaryEntries,
  fetchSearchList,
  hasMoreSearch,
  saveEntriesLoader,
  saveFromSearchFlag,
  saveScrollLoaderForward,
  saveSearchEntriesList,
  saveSearchEntryId,
  scrollLoaderForward,
  searchedEntriesList,
} from "redux/diaries/diariesSlice";
import { convertoUSFormat, redirectToUrl } from "utilities/generalUtility";
import moment from "moment";
import InfiniteScroll from "react-infinite-scroll-component/dist";

const { Text, Title } = Typography;
const { Search } = Input;

const title = (name, relation, topic) => (
  <>
    <Link to="/">
      <i class="icon-left-arrow"></i>
    </Link>

    <div className="lock-area">
      {/* <Tooltip title={"Unlock the journal"}>
        <i
          className="icon-unlock"
          style={{ cursor: "pointer" }}
          // onClick={() => {
          //   setnotifyModalOpen(true);
          // }}
        ></i>
      </Tooltip> */}

      <Title className="name mb-0" level={5}>
        <span>{name}</span>{" "}
        {relation && relation !== "" && (
          <Space className="relation mr-1" align="start" size={0}>
            <Divider type="vertical" />
            {relation}
          </Space>
        )}
      </Title>
    </div>
    <Link className="comunicate-issue" level={5}>
      <i className="icon-chat"></i>
      <span>{topic}</span>
    </Link>
  </>
);

export default function ResolveitSearch() {
  const [searchValue, setsearchValue] = useState("");
  const [debounce, setdebounce] = useState();
  const selected = useSelector(currentDiaryTopic);
  const dispatch = useDispatch();
  const searchList = useSelector(searchedEntriesList);
  const loading = useSelector(entriesLoader);
  const navigate = useNavigate();
  const currStatus = useSelector(diaryStatus);
  const diaryDetail = useSelector(currentDiaryDetail);
  const hasMoreSearchEntries = useSelector(hasMoreSearch);
  const forwardScrollLoad = useSelector(scrollLoaderForward);
  const inputRef = useRef(null);

  const handleSearch = (value) => {
    setsearchValue(value);
  };
  const highlightedString = (text) => {
    const parts = text.toLowerCase().split(searchValue.toLowerCase());

    const modifiedContent = parts.map((part, index) =>
      index === parts.length - 1 ? (
        <React.Fragment key={index}>
          {/* <Text>{searchValue}</Text> */}
          {part}
        </React.Fragment>
      ) : (
        <React.Fragment key={index}>
          {part}
          <Text>{searchValue}</Text>
        </React.Fragment>
      )
    );

    return modifiedContent;
  };

  const searchApiCall = (value, firstCall = false) => {
    try {
      selected?.diaryId &&
        (firstCall
          ? dispatch(saveEntriesLoader(true))
          : dispatch(saveScrollLoaderForward(true)));

      const body = {
        pageNumber: 0,
        pageSize: 15,
        searchType: 1,
        diaryId: selected?.diaryId,
        diaryTopicIds: [selected?.topicId],
        diaryEntryId: null,
        releasedEntryId: firstCall
          ? null
          : searchList[searchList.length - 1]?.releasedEntryId,
        direction: firstCall ? null : 2,
        searchString: value,
      };
      selected?.diaryId && dispatch(fetchSearchList(body, !firstCall));
    } catch (error) {}
  };

  const getSearchedEntries = (element) => {
    const body = {
      pageNumber: 0,
      pageSize: 10,
      searchType: 1,
      diaryId: selected?.diaryId,
      diaryTopicIds: [selected?.topicId],
      diaryEntryId: null,
      releasedEntryId: element?.releasedEntryId,
      direction: 3,
    };
    dispatch(saveFromSearchFlag(true));
    dispatch(saveSearchEntryId(element?.diaryEntryId));

    selected?.diaryId && dispatch(fetchDiaryEntries(body, false));
    setTimeout(() => {
      navigate("/");
    }, 500);
  };

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      setdebounce(searchValue);
    }, 700);
    return () => {
      clearTimeout(debounceTimer);
    };
  }, [searchValue]);

  useEffect(() => {
    if (debounce && debounce !== "") {
      searchApiCall(debounce, true);
    }
  }, [debounce]);

  useEffect(() => {
    selected?.diaryId
      ? dispatch(saveSearchEntriesList({ data: [] }))
      : navigate("/journal-request");
    if (inputRef) {
      inputRef?.current?.focus();
    }
  }, []);

  // const NotificationsSearch = (
  //   <>
  //     <div className="notification-header">
  //       <Link to="/">
  //         <i class="icon-left-arrow"></i>
  //       </Link>
  //     </div>
  //   </>
  // );

  return (
    <>
      <div className="resolvit-chat-wrapper">
        <Card
          title={title(
            currStatus?.diary?.userName,
            currStatus?.diary?.relationship,
            selected?.topicName
            // diaryDetail?.isLocked
          )}
          extra={
            <>
              {" "}
              <Search
                ref={inputRef}
                size="large"
                className="chat-message-search"
                placeholder="Search in entries"
                prefix={<i className="icon-search"></i>}
                value={searchValue}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </>
          }
          className="notification-box"
        >
          {!loading ? (
            searchList.length > 0 ? (
              <>
                <div
                  id="scrollableDiv"
                  style={{
                    position: "relative",
                  }}
                >
                  <InfiniteScroll
                    className="scroll-transparent"
                    dataLength={searchList.length}
                    next={() => searchApiCall(debounce)}
                    hasMore={hasMoreSearchEntries}
                    scrollableTarget="scrollableDiv"
                    height={300}
                    style={{
                      height: `calc(100vh - 173px)`,
                    }}
                  >
                    <ul>
                      {searchList.map((e) => {
                        return (
                          <li
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              getSearchedEntries(e);
                            }}
                          >
                            <div>
                              <h2>{e?.user?.firstName}</h2>
                              <p>{highlightedString(e?.text)}</p>
                            </div>
                            <p>{convertoUSFormat(moment, e.createdAt)} </p>
                          </li>
                        );
                      })}
                    </ul>
                  </InfiniteScroll>
                </div>
                {forwardScrollLoad && (
                  <Spin
                    spinning={forwardScrollLoad}
                    className="bottom-loading"
                  />
                )}{" "}
              </>
            ) : (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="No Search Result Found"
              />
            )
          ) : (
            <Spin spinning={loading}></Spin>
          )}
        </Card>
      </div>
    </>
  );
}
